const badgeMapping = {
  "Medical & Stiintific": "medical",
  "Birouri/Comercial": "comercial",
  "Cladiri rezidentiale private": "rezidential",
  "Infrastructura": "infrastructura",
  "Constructii sociale si Comunitate": "comunitate",
  Industrial: "industrial",
  "Utilitati": "utilitati",
  Retail: "retail",
  "Hotel & Relaxare": "hotel"
};

// topRegional = true  => ..._regional.svg
// topRegional = false => ..._national.svg
// isMoldovaEnvironment îl lăsăm în semnătură ca să nu stricăm call-urile,
// dar aici nu mai avem nevoie de el.
export const computeBadge = (topItem, topRegional, isMoldovaEnvironment) => {
  let badgePrefix =
    topItem.pozitie === 1
      ? "1"
      : topItem.pozitie <= 10
        ? "10"
        : topItem.pozitie <= 100
          ? "100"
          : topItem.pozitie <= 1000
            ? "1000"
            : "";

  let badgeName = badgeMapping[topItem.domeniu];

  // 1 = Proiectant => "p", restul "ag" (cum era la tine)
  let badgePositionName = topItem.contactPosition === 1 ? "p" : "ag";

  // Aici este schimbarea importantă:
  let badgeRegionName = topRegional ? "regional" : "national";

  const path = badgeName
    ? `/img/topuri/${badgePrefix}_${badgeName}_${badgePositionName}_${badgeRegionName}.svg`
    : null;

  console.log(path);

  return path;
};
